module.exports = __webpack_public_path__ + "media/images/flags/4x3/phl-b70e266bc49ac26c4ea08d20f32b25cf.svg";